import { render, staticRenderFns } from "./periodic-wizard-item.vue?vue&type=template&id=b8acabdc&"
import script from "./periodic-wizard-item.vue?vue&type=script&lang=js&"
export * from "./periodic-wizard-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports